import {Component, Inject, OnInit} from '@angular/core';
import {BookingCommonComponent} from '../../../booking-common.component';
import {Observable} from 'rxjs';
import {ICart, Store} from '../../../../store';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ItemService} from '../../../../services/item.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from '../../../../../environments/environment';
import {FacilityAdaptor} from '../../../../models/asset/facility-adaptor';
import {Item} from '../../../../models/item/item';

@Component({
  selector: 'opt-alternative-configuration-combined-room',
  templateUrl: './alternative-configuration-combined-room.component.html'
})
export class AlternativeConfigurationCombinedRoomComponent extends BookingCommonComponent implements OnInit {
  cart_subscriber: any;
  cart$: Observable<ICart>;
  facility: any;
  items: any;

  configurationDisplayMode: any;


  // configuration: any[];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _itemService: ItemService, public dialogRef: MatDialogRef<AlternativeConfigurationCombinedRoomComponent>
    , private store: Store<any>,snackBar:MatSnackBar) {
    super(store, _itemService,snackBar);

    this.configurationDisplayMode = environment.ConfigurationSelection.DisplayMode;
    this.facility = data.fc;
    this.items = data.fc.items;
  }

  ngOnInit() {
    //pasing the items to get the item configurations
    var items = this.facility.items;
    super.ngOnInit();
    super.calculateItemPrices([this.facility], this.facility.startTime, this.facility.endTime,true);
  }
  //returning the relevent configuration for the item
  configurations(item) {

    return FacilityAdaptor.getFacilityConfigurations(this.facility, item);
  }

  //ngOnDestroy() {
  //    if (this.cart_subscriber)
  //        this.cart_subscriber.unsubscribe();

  //}


  //add relevent Titem
  addToBookingAlternative(item: Item) {
    this.facility.selectedItem = item;

    this.facility.selectedConfiguration = FacilityAdaptor.getConfiguration(this.facility.selectedItem, this.facility);
    //this.facility.item = item;
    //this.facility.item.calculatedMinPrice.priceIncludingTax = item.calculatedMinPrice.priceIncludingTax;
    //this.facility.item.calculatedMaxPrice.priceIncludingTax = item.calculatedMaxPrice.priceIncludingTax;
    this.dialogRef.close();
  }
}
